export default "__VITE_ASSET__BbL54Gkn__"